/* tslint:disable */
/* eslint-disable */
/**
 * gremiumhub
 * A platform for digital applications, approvals and discussions.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: denis.lugowski@gmail.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { InputType } from './InputType';
import {
    InputTypeFromJSON,
    InputTypeFromJSONTyped,
    InputTypeToJSON,
    InputTypeToJSONTyped,
} from './InputType';
import type { VisibilityConditionGroup } from './VisibilityConditionGroup';
import {
    VisibilityConditionGroupFromJSON,
    VisibilityConditionGroupFromJSONTyped,
    VisibilityConditionGroupToJSON,
    VisibilityConditionGroupToJSONTyped,
} from './VisibilityConditionGroup';
import type { TableRowConstraintDto } from './TableRowConstraintDto';
import {
    TableRowConstraintDtoFromJSON,
    TableRowConstraintDtoFromJSONTyped,
    TableRowConstraintDtoToJSON,
    TableRowConstraintDtoToJSONTyped,
} from './TableRowConstraintDto';
import type { TableCellAdvisoryDto } from './TableCellAdvisoryDto';
import {
    TableCellAdvisoryDtoFromJSON,
    TableCellAdvisoryDtoFromJSONTyped,
    TableCellAdvisoryDtoToJSON,
    TableCellAdvisoryDtoToJSONTyped,
} from './TableCellAdvisoryDto';
import type { TableColumnFilterDto } from './TableColumnFilterDto';
import {
    TableColumnFilterDtoFromJSON,
    TableColumnFilterDtoFromJSONTyped,
    TableColumnFilterDtoToJSON,
    TableColumnFilterDtoToJSONTyped,
} from './TableColumnFilterDto';
import type { TableRowVisibilityConditionDto } from './TableRowVisibilityConditionDto';
import {
    TableRowVisibilityConditionDtoFromJSON,
    TableRowVisibilityConditionDtoFromJSONTyped,
    TableRowVisibilityConditionDtoToJSON,
    TableRowVisibilityConditionDtoToJSONTyped,
} from './TableRowVisibilityConditionDto';

/**
 * Configuration for table column cross-references
 * @export
 * @interface TableColumnConfigDto
 */
export interface TableColumnConfigDto {
    /**
     * Reference to source table element to get values from
     * @type {string}
     * @memberof TableColumnConfigDto
     */
    sourceTableReference?: string;
    /**
     * Index of source column to reference (0-based)
     * @type {number}
     * @memberof TableColumnConfigDto
     */
    sourceTableColumnIndex?: number;
    /**
     * 
     * @type {TableColumnFilterDto}
     * @memberof TableColumnConfigDto
     */
    sourceTableValueFilter?: TableColumnFilterDto;
    /**
     * 
     * @type {TableRowConstraintDto}
     * @memberof TableColumnConfigDto
     */
    crossTableValueConstraint?: TableRowConstraintDto;
    /**
     * If true, column values cannot be edited by user
     * @type {boolean}
     * @memberof TableColumnConfigDto
     */
    isReadOnly?: boolean;
    /**
     * If true, allows selecting multiple values in this column
     * @type {boolean}
     * @memberof TableColumnConfigDto
     */
    isMultipleAllowed?: boolean;
    /**
     * If true, values already selected in other rows of this column are removed from the dropdown options (each value can be chosen once across all rows).
     * @type {boolean}
     * @memberof TableColumnConfigDto
     */
    isUniqueInThisColumn?: boolean;
    /**
     * 
     * @type {VisibilityConditionGroup}
     * @memberof TableColumnConfigDto
     */
    formColumnReadOnlyConditions?: VisibilityConditionGroup;
    /**
     * Value to write into each cell when the column transitions to read-only via formColumnReadOnlyConditions.
     * @type {string}
     * @memberof TableColumnConfigDto
     */
    readOnlyLockValue?: string;
    /**
     * 
     * @type {TableRowVisibilityConditionDto}
     * @memberof TableColumnConfigDto
     */
    sameRowCellVisibility?: TableRowVisibilityConditionDto;
    /**
     * Predefined list of selectable values for this column. Renders as a multi-select dropdown.
     * @type {Array<string>}
     * @memberof TableColumnConfigDto
     */
    selectOptions?: Array<string>;
    /**
     * If true, every visible cell in this column must be filled for the table to be considered complete. Cells hidden by sameRowCellVisibility and columns hidden by optionVisibilityConditions are not checked.
     * @type {boolean}
     * @memberof TableColumnConfigDto
     */
    isRequired?: boolean;
    /**
     * 
     * @type {InputType}
     * @memberof TableColumnConfigDto
     */
    inputType?: InputType;
    /**
     * Lowest accepted value for NUMBER/INTEGER cells. Typing a smaller value is prevented and out-of-range values are clamped up to it on commit. Ignored for other input kinds.
     * @type {number}
     * @memberof TableColumnConfigDto
     */
    minValue?: number;
    /**
     * Highest accepted value for NUMBER/INTEGER cells. Out-of-range values are clamped down to it on commit. Ignored for other input kinds.
     * @type {number}
     * @memberof TableColumnConfigDto
     */
    maxValue?: number;
    /**
     * Row-scoped advisory notes attached to this column. An advisory is guidance about the value entered in this column, not data: it renders as an inline hint on the cell's own input and is excluded from the PDF/BV export.
     * @type {Array<TableCellAdvisoryDto>}
     * @memberof TableColumnConfigDto
     */
    cellAdvisories?: Array<TableCellAdvisoryDto>;
}



/**
 * Check if a given object implements the TableColumnConfigDto interface.
 */
export function instanceOfTableColumnConfigDto(value: object): value is TableColumnConfigDto {
    return true;
}

export function TableColumnConfigDtoFromJSON(json: any): TableColumnConfigDto {
    return TableColumnConfigDtoFromJSONTyped(json, false);
}

export function TableColumnConfigDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): TableColumnConfigDto {
    if (json == null) {
        return json;
    }
    return {
        
        'sourceTableReference': json['sourceTableReference'] == null ? undefined : json['sourceTableReference'],
        'sourceTableColumnIndex': json['sourceTableColumnIndex'] == null ? undefined : json['sourceTableColumnIndex'],
        'sourceTableValueFilter': json['sourceTableValueFilter'] == null ? undefined : TableColumnFilterDtoFromJSON(json['sourceTableValueFilter']),
        'crossTableValueConstraint': json['crossTableValueConstraint'] == null ? undefined : TableRowConstraintDtoFromJSON(json['crossTableValueConstraint']),
        'isReadOnly': json['isReadOnly'] == null ? undefined : json['isReadOnly'],
        'isMultipleAllowed': json['isMultipleAllowed'] == null ? undefined : json['isMultipleAllowed'],
        'isUniqueInThisColumn': json['isUniqueInThisColumn'] == null ? undefined : json['isUniqueInThisColumn'],
        'formColumnReadOnlyConditions': json['formColumnReadOnlyConditions'] == null ? undefined : VisibilityConditionGroupFromJSON(json['formColumnReadOnlyConditions']),
        'readOnlyLockValue': json['readOnlyLockValue'] == null ? undefined : json['readOnlyLockValue'],
        'sameRowCellVisibility': json['sameRowCellVisibility'] == null ? undefined : TableRowVisibilityConditionDtoFromJSON(json['sameRowCellVisibility']),
        'selectOptions': json['selectOptions'] == null ? undefined : json['selectOptions'],
        'isRequired': json['isRequired'] == null ? undefined : json['isRequired'],
        'inputType': json['inputType'] == null ? undefined : InputTypeFromJSON(json['inputType']),
        'minValue': json['minValue'] == null ? undefined : json['minValue'],
        'maxValue': json['maxValue'] == null ? undefined : json['maxValue'],
        'cellAdvisories': json['cellAdvisories'] == null ? undefined : ((json['cellAdvisories'] as Array<any>).map(TableCellAdvisoryDtoFromJSON)),
    };
}

export function TableColumnConfigDtoToJSON(json: any): TableColumnConfigDto {
    return TableColumnConfigDtoToJSONTyped(json, false);
}

export function TableColumnConfigDtoToJSONTyped(value?: TableColumnConfigDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'sourceTableReference': value['sourceTableReference'],
        'sourceTableColumnIndex': value['sourceTableColumnIndex'],
        'sourceTableValueFilter': TableColumnFilterDtoToJSON(value['sourceTableValueFilter']),
        'crossTableValueConstraint': TableRowConstraintDtoToJSON(value['crossTableValueConstraint']),
        'isReadOnly': value['isReadOnly'],
        'isMultipleAllowed': value['isMultipleAllowed'],
        'isUniqueInThisColumn': value['isUniqueInThisColumn'],
        'formColumnReadOnlyConditions': VisibilityConditionGroupToJSON(value['formColumnReadOnlyConditions']),
        'readOnlyLockValue': value['readOnlyLockValue'],
        'sameRowCellVisibility': TableRowVisibilityConditionDtoToJSON(value['sameRowCellVisibility']),
        'selectOptions': value['selectOptions'],
        'isRequired': value['isRequired'],
        'inputType': InputTypeToJSON(value['inputType']),
        'minValue': value['minValue'],
        'maxValue': value['maxValue'],
        'cellAdvisories': value['cellAdvisories'] == null ? undefined : ((value['cellAdvisories'] as Array<any>).map(TableCellAdvisoryDtoToJSON)),
    };
}

